function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeposit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "red",
    stroke: "red",
    width: "100%",
    height: "100%",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.836591,0,0,1,6.93383,-0.768084)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.09774,0,0,1,5.80509,-1.53053)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.691,
    y: 7.952,
    width: 12.31,
    height: 4.396,
    style: {
      fill: "none",
      strokeWidth: 3
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.19533,0,0,1,-17.7611,0.768084)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.033,38.543C24.326,33.169 33.703,29.544 33.951,25.433L33.95,25.346L33.95,9.24L43.769,9.24L43.769,25.346L43.768,25.433C44.016,29.552 53.432,33.183 53.688,38.576L53.688,94.347L24.032,94.347L24.032,38.576L24.033,38.543Z",
    style: {
      fill: "none",
      strokeWidth: 3,
      strokeLinejoin: "bevel"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.923658,0,0,0.923658,6.91376,7.20778)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,0.947953,-6.06142,4.91047)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 66.342,
    y: 57.036,
    width: 28.952,
    height: 37.311,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.342,
    y: 57.036,
    width: 28.952,
    height: 37.311,
    style: {
      fill: "none",
      strokeWidth: 3,
      strokeLinejoin: "bevel"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.02252,0,0,1.41811,0.0613107,-26.3228)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 55.044,
    y: 54.781,
    width: 36.014,
    height: 6.179,
    style: {
      fill: "none",
      strokeWidth: 3
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeposit);
export default __webpack_public_path__ + "static/media/deposit.589565ad97f3aba92915ba93d5789643.svg";
export { ForwardRef as ReactComponent };